var React = require('react');

function IconDDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF"},React.createElement("path",{"d":"M1 4L8 11L15 4z"})));
}

IconDDown.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = IconDDown;

IconDDown.default = IconDDown;
